import { render, staticRenderFns } from "./GoodsAddress.vue?vue&type=template&id=4ac7513f&scoped=true&"
import script from "./GoodsAddress.vue?vue&type=script&lang=js&"
export * from "./GoodsAddress.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAddress.vue?vue&type=style&index=0&id=4ac7513f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac7513f",
  null
  
)

export default component.exports